// extracted by mini-css-extract-plugin
export default {"mainContainer":"Result_mainContainer__MMF1p","gridContainer":"Result_gridContainer__GoRXC"};